import { type ReactNode, useId } from "react";

// All Home tabs use this section shell so titles and spacing stay consistent.
export function HomeSection({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  const headingId = useId();
  return (
    <section aria-labelledby={headingId} className="space-y-4">
      <h2 id={headingId} className="application-section-title">
        {title}
      </h2>
      {children}
    </section>
  );
}
